module.exports = __webpack_public_path__ + "f2d1fb75f1745e8cab010a3f0bbfedb7.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/logo.svg
// module id = yxVw
// module chunks = 12